// extracted by mini-css-extract-plugin
export default {"valueContainer":"ValueContainer_valueContainer__IFu6V"};